import { UnitTypes } from './unit-types';

export const UNIT_TYPE_LABEL_MAP: Record<UnitTypes, string> = {
  [UnitTypes.Milliliters]: 'Літри',
  [UnitTypes.Coins]: 'Гривні',
  [UnitTypes.Pcs]: 'Штуки',
  [UnitTypes.Transactions]: 'Транзакції',
};
